import React, { useContext, useEffect, useState } from 'react';
import "./CheckoutNavigator.css";
import Button from "react-bootstrap/Button";
import classnames from "classnames";
import CheckoutStepper from '../CheckoutStepper/CheckoutStepper';
import { addAlphaToHex } from '../../utils';
import { IoChevronForwardCircleOutline, IoChevronBackCircleOutline } from "react-icons/io5";
import { Store } from '../../Store';



export default function CheckoutNavigator({ previousStepHandler, nextStepHandler, backButtonText = "Volver", forwardButtonText = "Continuar",
  showForwardIcon = true, showBackIcon = true, activeStep, nextStepDisabled = false}) {
  const { state } = useContext(Store);
  const {usesShipping} = state;
  const [buttonColor, setButtonColor] = useState('');
  useEffect(() => {
    const dimmedButtonColor = addAlphaToHex(getComputedStyle(document.documentElement)
      .getPropertyValue('--secondaryColor').replace("#", ""), 0.5);
    setButtonColor(dimmedButtonColor);
  }, []);

  return <div id="checkout-navigator">
    <div className="w-100 d-flex align-items-center desktop">
      {<Button onClick={previousStepHandler} disabled = {!previousStepHandler} className={classnames('d-sm-flex d-none', { 'invisible': !previousStepHandler })}>
        {showBackIcon && <IoChevronBackCircleOutline />}
        {backButtonText}
      </Button>}
      <CheckoutStepper activeStep={activeStep} usesShipping={usesShipping}/>
      <Button onClick={nextStepHandler} disabled = {nextStepDisabled} className={classnames('d-sm-flex d-none', { 'invisible': !nextStepHandler })}>
        {forwardButtonText}
        {showForwardIcon && <IoChevronForwardCircleOutline />}
      </Button>
    </div>
    <div className={classnames('bottom-section d-sm-none',
     { 'justify-content-end' : !previousStepHandler && nextStepHandler  , 'justify-content-between': previousStepHandler && nextStepHandler
       , 'justify-content-start': previousStepHandler && !nextStepHandler
      })}>
      {previousStepHandler && <Button onClick = {previousStepHandler}>
        {showBackIcon && <IoChevronBackCircleOutline />}
        {backButtonText}
      </Button>}
      { nextStepHandler && 
        <Button onClick={nextStepHandler} disabled = {nextStepDisabled} >
        {forwardButtonText}
        { showForwardIcon && <IoChevronForwardCircleOutline />}
      </Button>
      }
    </div>
  </div>
}
